<template>
  <cTable ref="table" :fields="fields" :methods="methods" :modals="modals" :config="config" :footer="footer">
    <template #header>
      <Card style="margin-bottom: 10px">
        <span slot="title">
          {{ $t("transportation") + $t("information") }}
        </span>
        <Form :model="dataDetails" :label-width="120">
          <Row :gutter="10" style="padding-top: 10px; margin: -16px">
            <Col span="5">
            <FormItem :label="$t('dingcangCompany')">
              <Input v-model="dataDetails.dingcangCompany" disabled></Input>
            </FormItem>
            </Col>
            <Col span="6">
            <FormItem :label="$t('method_name')">
              <Input v-model="dataDetails.transport" disabled> </Input>
            </FormItem>
            </Col>
            <Col span="6">
            <FormItem :label="$t('company')">
              <Input v-model="dataDetails.service" disabled> </Input>
            </FormItem>
            </Col>
            <Col span="6">
            <FormItem :label="$t('from_country')">
              <Input v-model="dataDetails.from_country" disabled> </Input>
            </FormItem>
            </Col>
            <Col span="5">
            <FormItem :label="$t('target_country')">
              <Input v-model="dataDetails.to_country" disabled> </Input>
            </FormItem>
            </Col>
            <Col span="6">
            <FormItem :label="$t('is_solely')">
              <Input :value="dataDetails.is_solely === 'NO' ? $t('NO') : $t('YES')">
              </Input>
            </FormItem>
            </Col>

            <Col span="6">
            <FormItem :label="$t('warehouseName')" prop="cangku">
              <Input v-model="dataDetails.warehouse" disabled></Input>
            </FormItem>
            </Col>
            <Col span="6">
            <FormItem :label="$t('special_remark')">
              <Input type="textarea" v-model="finance_remarks" :rows="2"></Input>
            </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { getChargingType, getItem } from "@/api/double/list";
import { getBranchList, saveBranchFeright } from "@/api/double/branch_feright";
export default {
  components: {
    cTable,
  },
  props: {
    row: {
      type: Object,
    },
    close: {
      type: Function,
    },
  },
  data() {
    return {
      dataDetails: {},
      finance_remarks: "",
      setSelect: {
        currency: [
          { label: this.$t("to_rmb"), value: "CNY" },
          { label: this.$t("to_usd"), value: "USD" },
          { label: this.$t("to_sar"), value: "SAR" },
          { label: this.$t("to_aed"), value: "AED" },
        ],
      },

      methods: {
        getChargingType,
        getItem,
      },
      modals: {
        show: {
          config: {
            modalBind: {
              width: 800,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 700,
            },
            fields: [
              {
                name: () => this.$t("packing_number"),
                key: "packing_number",
                tooltip: true,
                minWidth: 120,
              },
              {
                name: () => this.$t("number_of_bags"),
                key: "quantity",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("skuVolume"),
                key: "volume",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("charge_volume"),
                key: "volume_weight",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("actual_weight"),
                key: "actual_weight",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
      },
      config: {
        height: 500,
        resize: false,
        slot: "div",
        row: this.row,
      },
      footer: { show: () => false },
      fields: [
        {
          name: () => this.$t("expense_item") + "(" + this.$t("Required") + ")",
          key: "expense_item",
          align: "left",
          component: "Select",
          placeholder: () => {
            return this.$t("select") + this.$t("expense_item");
          },
          options: [],
          bind: {
            transfer: true,
          },
          // methods: {
          //   "on-change"({ value, rowIndex, field }) {
          //     this.list[rowIndex][field.key] = value;
          //   }
          // }
        },
        {
          name: () => this.$t("expType") + "(" + this.$t("Required") + ")",
          key: "unit_name",
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("expense");
          },
          options: [],
          bind: {
            transfer: true,
          },
        },
        {
          name: () => this.$t("doublePrice") + "(" + this.$t("Required") + ")",
          key: "price",
          component: "InputNumber",
          placeholder() {
            return this.$t("enter") + this.$t("doublePrice");
          },
          options: [],
        },
        {
          name: () => this.$t("currencyCode") + "(" + this.$t("Required") + ")",
          key: "currency",
          component: "Select",
          align: "left",
          placeholder() {
            return this.$t("Billing") + this.$t("number");
          },
          bind: {
            transfer: true,
          },
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          component: "Input",
          placeholder() {
            return this.$t("enter") + this.$t("Remarks");
          },
        },
        {
          type: "btns",
          width: 160,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                type: "warning",
              },
              icon: "md-add",
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              icon: "md-trash",
              disabled() {
                return this.list.length === 1;
              },
            },
          ],
          methods: {
            add() {
              const data = {
                expense_item: "",
                unit_name: "",
                price: 0,
                currency: "",
                remarks: "",
              };
              this.list.unshift(data);
            },
            delete({ rowIndex }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.list.splice(rowIndex, 1);
                },
              });
            },
          },
        },
      ],
    };
  },
  async mounted() {
    getBranchList(this.row).then((res) => {
      this.dataDetails = res.data.payload;
    });
    const data = {
      expense_item: "",
      unit_name: "",
      price: 0,
      currency: "",
      remarks: "",
    };
    this.$refs["table"].list.push(data);
    this.setSelect.expense_item = (await getItem()).data.payload;
    console.log(this.row, 'this.row');
    this.setSelect.unit_name = (await getChargingType({ airway_number: this.row.airway_number })).data.payload;
    this.fields.forEach((el) => {
      if (this.setSelect[el.key] && el.key) el.options = this.setSelect[el.key];
    });
  },

  methods: {
    save() {
      let data = {
        ...this.row,
        finance_remarks: this.finance_remarks,
        finance: this.$refs["table"].list,
      };
      saveBranchFeright(data).then((res) => {
        if (res.data.status) {
          this.$Message["success"]({
            background: true,
            content: res.data.msg,
          });
          this.close();
        }
      });
    },
  },
};
</script>
<style scoped>
.footer-btn {
  border-top: 1px solid #e8eaec;
  display: flex;
  justify-content: end;
}
</style>
